import { Card, Col, Row, Empty, Typography, Divider } from "antd";
import { VITE_API_BASE_URL } from "../../config";

const { Title, Text } = Typography;

const NotableAlumni = ({ institution }) => {
  const { notable_alumni = [] } = institution;

  if (notable_alumni.length === 0) {
    return <Empty description="No notable alumni found." className="my-8" />;
  }

  return (
    <div className="pt-5 pb-6">
      <Row gutter={[24, 24]}>
        {notable_alumni.map((alumnus) => {
          const fullName = `${alumnus.first_name} ${alumnus.last_name}`;
          const photoURL = alumnus.photo
            ? `${VITE_API_BASE_URL}/files/alumni/${alumnus.photo}`
            : null;

          return (
            <Col key={alumnus.id} xs={24} sm={12} md={6}>
              <Card
                className="border border-gray-200! hover:shadow-sm transition-all"
                cover={
                  photoURL ? (
                    <div className="aspect-[2/2] overflow-hidden">
                      <img
                        alt="Alumnus"
                        src={photoURL}
                        className="w-full h-full object-cover object-center"
                      />
                    </div>
                  ) : null
                }
              >
                <div className="space-y-2 text-sm text-gray-700">
                  <Title level={5} className="text-gray-800">
                    {fullName}
                  </Title>

                  {alumnus.description && (
                    <Text className="block text-gray-600">
                      {alumnus.description}
                    </Text>
                  )}

                  {alumnus.achievements && (
                    <>
                      <Divider className="my-2" />
                      <Text type="secondary" className="text-xs">
                        <strong>Achievements:</strong>{" "}
                        {alumnus.achievements || "—"}
                      </Text>
                    </>
                  )}
                </div>
              </Card>
            </Col>
          );
        })}
      </Row>
    </div>
  );
};

export default NotableAlumni;
